import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { CheckBox } from 'components/CheckBox';
import { large } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';
import { paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Container = styled.div`
  ${container}

  margin-top: 33px;
  padding-right: 8px;
  text-align: left;

  ${large`
    padding-right: 0;
  `}
`;

export const Buttons = styled.div`
  ${container}

  margin-top: 61px;

  ${large`
    margin-top: 13px;
  `}
`;

export const TextBoxGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CheckboxStyled = styled(CheckBox)`
  margin: 0 0 0 40px;
`;

export const NoteContainer = styled.p`
  ${paragraph}

  font-style: italic;
  margin: 19px 0 0 40px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;
